import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledLink = styled.a`
  color: var(--ag-foreground-color);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const QuestionLinkRenderer = ({ value, data }) => {
  if (!value) return 'N/A';

  const url = `https://app.supper.co/chats/${data.conversationId}?organization_id=${data.organizationId}#${data.id}`;

  return (
    <StyledLink href={url} target='_blank' rel='noopener noreferrer'>
      {value}
    </StyledLink>
  );
};

QuestionLinkRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    conversationId: PropTypes.string.isRequired,
    organizationId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }).isRequired
};

export { QuestionLinkRenderer };
